import { FaIcon } from '@/lib/fa'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import React from 'react'

const CardHistoryHeader = ({handleClose}) => {
  return (
       <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-base-300 tw-p-4">
                 <div className="tw-flex tw-items-center tw-gap-4">
                   <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
                     Dane z kart
                   </p>
                 </div>
                 <FaIcon
                   icon={faClose}
                   className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer tw-text-content-base hover:tw-text-primary"
                   onClick={() => handleClose()}
                 />
               </div>
  )
}

export default CardHistoryHeader